import React from "react";
import { useScrollLock } from "./useScrollLock";
import "./taskModal.css";

function preventBackdropScroll(event) {
  event.preventDefault();
}

function TaskModalRoot({ open, onBackdropClick, children, className = "" }) {
  useScrollLock(open);

  if (!open) return null;

  return (
    <div
      className={`task-modal-root fixed inset-0 z-50 flex items-center justify-center overflow-hidden p-3 sm:p-4 ${className}`.trim()}
    >
      <div
        className="task-modal-backdrop absolute inset-0 z-0 bg-black/40"
        onClick={onBackdropClick}
        onWheel={preventBackdropScroll}
        onTouchMove={preventBackdropScroll}
        aria-hidden="true"
      />
      {children}
    </div>
  );
}

export default TaskModalRoot;
